import './ProductType.scss';

interface ProductTypeProps {
  title: string;
  description: string;
  onClick?: () => void;
}

const ProductType = ({ title, description, onClick }: ProductTypeProps) => {
  return (
    <div className="product-type" onClick={onClick}>
      <h1 className="product-type-title">{title}</h1>
      <p className="product-type-description">{description}</p>
    </div>
  );
};

export default ProductType;
